/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import UserModel from 'cio/models/user';
import AccountService from 'cio/services/account';
import MomentService from 'cio/services/moment';
import moment from 'moment-timezone';

interface MasqAccessPopoverArgs {
  accessSource: string;
  grantedOn: number;
  grantedByUser: UserModel;
  grantedUntil: number;
  masqedInUser: UserModel;
  teamAccessGranted: boolean;
}

export default class MasqAccessPopover extends Component<MasqAccessPopoverArgs> {
  @service account!: AccountService;
  @service moment!: MomentService;

  get isSupportAccessGranted() {
    return this.args.masqedInUser.hasReadMasqAccess;
  }

  get isInternalAccessEnabled() {
    return !(
      this.args.masqedInUser.masqLevelNotSet ||
      (this.args.masqedInUser.noMasqAccess && this.args.teamAccessGranted)
    );
  }

  get grantedUntilShortDate() {
    return this.moment.formatTimestamp([this.args.grantedUntil], {
      finalFormatter: (timestampAsMoment: moment.Moment) => timestampAsMoment.format('MMM D, YYYY'),
    });
  }

  get grantedOnShortDate() {
    if (this.args.grantedOn == null) {
      return null;
    }
    return this.moment.formatTimestamp([this.args.grantedOn], {
      finalFormatter: (timestampAsMoment: moment.Moment) => timestampAsMoment.format('MMM D, YYYY'),
    });
  }

  get grantedByUserEmail() {
    return this.args.grantedByUser.email;
  }
}
